import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/images/pricing-star.png'


const _withScopeId = (n: any) => (_pushScopeId("data-v-4b239c20"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pricing-table-wrap pt-20 pb-20" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row justify-content-center" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-xl-12 col-lg-12 col-md-12" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "pricing-table style1" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "pricing-header" }, [
      /*#__PURE__*/_createElementVNode("h3", null, [
        /*#__PURE__*/_createElementVNode("img", {
          src: _imports_0,
          alt: "Image"
        }),
        /*#__PURE__*/_createTextVNode("Règlementation UPU et Divers Guides")
      ])
    ])
  ])
], -1))
const _hoisted_5 = ["href"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "ri-download-fill" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.articles, (article, index) => {
            return (_openBlock(), _createElementBlock("a", {
              class: "btn btn-primary upu",
              key: index,
              target: "_blank",
              rel: "noopener noreferrer",
              href: article.source ? article.source : _ctx.getUrlApiForFiles(article.urlImage)
            }, [
              _createTextVNode(_toDisplayString(article.titre) + " ", 1),
              _hoisted_6
            ], 8, _hoisted_5))
          }), 128))
        ])
      ])
    ])
  ]))
}